import { calcResize } from 'components/Layout/styles';
import styled from 'styled-components';

// Example of use. Delete if not needed.
export const SH1 = styled.h1`
  font-size: ${calcResize(36, 60)};
`;

// Example of use. Delete if not needed.
export const SH2 = styled.h2`
  font-size: ${calcResize(36, 60)};
`;

export const SDescription = styled.p.attrs(() => ({
  className: 'mt-4',
}))`
  color: ${props =>
    props.mode ? props.mode === 'dark' && props.theme.colors.main : '#ffffff'};
`;
